<template>
<div class="chapter">
<div class="inner_page">
<p class="P_TOC_Heading" id="tableofcontents"><span>Contents</span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0001#auto_bookmark_toc_1">Book Description</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0002#auto_bookmark_toc_1">Title Page</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0004#auto_bookmark_toc_1">Introduction</a></span></p>
<p class="P_TOC_Entry_1"><span><a href="#/section0005#auto_bookmark_toc_1">The Butlerian Jihad Period</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0005#auto_bookmark_toc_3">Hunting Harkonnens</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0005#auto_bookmark_toc_16">Whipping Mek</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0005#auto_bookmark_toc_18">The Faces of a Martyr</a></span></p>
<p class="P_TOC_Entry_2"><span><a href="#/section0005#auto_bookmark_toc_20">Red Plague</a></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0006#auto_bookmark_toc_1" title="Link target outside of Sample">The Dune Period</span></span></p>
<p class="P_TOC_Entry_2"><span><span href="#/section0006#auto_bookmark_toc_3" title="Link target outside of Sample">Wedding Silk</span></span></p>
<p class="P_TOC_Entry_2"><span><span href="#/section0006#auto_bookmark_toc_5" title="Link target outside of Sample">A Whisper of Caladan Seas</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0007#auto_bookmark_toc_1" title="Link target outside of Sample">After the Scattering</span></span></p>
<p class="P_TOC_Entry_2"><span><span href="#/section0007#auto_bookmark_toc_3" title="Link target outside of Sample">Sea Child</span></span></p>
<p class="P_TOC_Entry_2"><span><span href="#/section0007#auto_bookmark_toc_5" title="Link target outside of Sample">Treasure in the Sand</span></span></p>
<p class="P_TOC_Entry_2"><span><span href="#/section0008#auto_bookmark_toc_1" title="Link target outside of Sample">Chronology of Dune Fiction</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0009#auto_bookmark_toc_1" title="Link target outside of Sample">About the Author</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0010#auto_bookmark_toc_1" title="Link target outside of Sample">If You Liked …</span></span></p>
<p class="P_TOC_Entry_1"><span><span href="#/section0011#auto_bookmark_toc_1" title="Link target outside of Sample">Other WordFire Press Titles</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?31ff7a93